// extracted by mini-css-extract-plugin
export default {"remove_message_heading":"GroupDelete_remove_message_heading__+Yopc","row":"GroupDelete_row__mQsCg","imei":"GroupDelete_imei__hDLrH"};